module.exports = __webpack_public_path__ + "static/media/2.afa37553.png";